import React from 'react';

export const company= {
  ecards: []
}

export const CompanyContext = React.createContext({
  company: company
});